var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #bfeaea;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-3, .cls-4, .cls-2, .cls-5 {\n        stroke: #00a9a9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 30px;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #40bfbf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 600,
    cy: 600.18,
    r: 557.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 240.6,
    y: 567.11,
    width: 221.7,
    height: 364.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 731.12,
    y: 567.11,
    width: 221.7,
    height: 364.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "731.12 567.62 731.12 463.11 595.03 361.88 462.3 463.11 462.3 567.62 462.3 931.61 731.12 931.61 731.12 567.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M569.21,931.61h-27.42v-136.36c0-10.49,8.39-19.03,18.88-19.03h72.23c10.34,0,18.73,8.54,18.73,19.03v136.36h-82.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M596.23,243.62v-17.63s87.68,0,87.68,0c6.74,0,12.24,5.4,12.24,12.14v46.44c0,6.65-5.49,12.04-12.24,12.04h-87.68s0-17.63,0-17.63v-35.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 594.51,
    cy: 564.11,
    r: 53.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 312.53,
    y1: 646.75,
    x2: 312.53,
    y2: 697.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 391.77,
    y1: 646.75,
    x2: 391.77,
    y2: 697.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 312.53,
    y1: 790,
    x2: 312.53,
    y2: 840.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 391.77,
    y1: 790,
    x2: 391.77,
    y2: 840.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 803.34,
    y1: 646.75,
    x2: 803.34,
    y2: 697.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 882.58,
    y1: 646.75,
    x2: 882.58,
    y2: 697.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 803.34,
    y1: 790,
    x2: 803.34,
    y2: 840.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 882.58,
    y1: 790,
    x2: 882.58,
    y2: 840.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 596.23,
    y1: 361.88,
    x2: 596.23,
    y2: 225.99
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.b563fb1067aa5789712ce57b623196da.svg";
export { ForwardRef as ReactComponent };